module.exports = __webpack_public_path__ + "img/keeper_of_the_grove_small.93d44252.png";